import React from "react";
import { Table } from "react-bootstrap";

import { onOffLabel } from "./setLabels";

const TOTAL_LABELS = { images_downloaded: "Images downloaded from links" };

// "wrong_answers_created" reads "Wrong answers created".
const totalLabel = (key) => {
  if (TOTAL_LABELS[key]) return TOTAL_LABELS[key];
  const words = key.replace(/_/g, " ");
  return words.charAt(0).toUpperCase() + words.slice(1);
};

const nonZeroTotals = (totals = {}) => Object.entries(totals).filter(([, value]) => value !== 0);

const SET_COLUMNS = [
  "Key",
  "Name",
  "Questions",
  "Change",
  "On after import",
  "Sheet status",
  "Held",
  "Removed questions",
  "Unused misconceptions",
];

const joined = (values = []) => values.join(", ");

/** The report of an upload the server accepted. */
export const ImportReport = ({ report }) => {
  const totals = nonZeroTotals(report.totals);
  const sets = report.sets || [];

  return (
    <div className="mt-4">
      <p>{report.dry_run ? "Check passed: nothing was written." : "Imported."}</p>
      {totals.length > 0 && (
        <Table striped bordered size="sm" aria-label="Totals">
          <thead>
            <tr>
              <th>Total</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {totals.map(([key, value]) => (
              <tr key={key}>
                <td>{totalLabel(key)}</td>
                <td>{value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      {sets.length > 0 && (
        <Table striped bordered size="sm" aria-label="Sets in the files">
          <thead>
            <tr>
              {SET_COLUMNS.map((column) => (
                <th key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sets.map((set) => (
              <tr key={set.key}>
                <td>{set.key}</td>
                <td>{set.name}</td>
                <td>{set.question_count}</td>
                <td>{set.action}</td>
                <td>{onOffLabel(set.active)}</td>
                <td>{set.sheet_status ?? ""}</td>
                <td>{set.held_reason ?? ""}</td>
                <td>{joined(set.removed_question_keys)}</td>
                <td>{joined(set.unused_misconceptions)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};
